interface SortableHeaderProps<K extends string> {
  label: string
  sortKey: K
  currentKey: K
  currentDir: 'asc' | 'desc'
  onToggle: (key: K) => void
  className?: string
}

export function SortableHeader<K extends string>({
  label, sortKey, currentKey, currentDir, onToggle, className = '',
}: SortableHeaderProps<K>) {
  const isActive = currentKey === sortKey
  const icon = isActive ? (currentDir === 'asc' ? '↑' : '↓') : '↕'
  return (
    <button
      onClick={() => onToggle(sortKey)}
      className={`flex items-center gap-0.5 cursor-pointer select-none transition-colors ${
        isActive ? 'text-white' : 'text-gray-500 hover:text-white'
      } ${className}`}
    >
      {label}
      <span className={`text-[10px] ml-0.5 ${isActive ? 'text-white' : 'text-gray-600'}`}>{icon}</span>
    </button>
  )
}

interface SortBarOption<K extends string> {
  label: string
  key: K
}

interface SortBarProps<K extends string> {
  options: SortBarOption<K>[]
  currentKey: K
  currentDir: 'asc' | 'desc'
  onToggle: (key: K) => void
  className?: string
}

export function SortBar<K extends string>({ options, currentKey, currentDir, onToggle, className = '' }: SortBarProps<K>) {
  return (
    <div className={`flex items-center gap-1.5 flex-wrap text-xs ${className}`}>
      <span className="text-gray-600 shrink-0">Sort:</span>
      {options.map(opt => {
        const isActive = currentKey === opt.key
        const icon = isActive ? (currentDir === 'asc' ? ' ↑' : ' ↓') : ''
        return (
          <button
            key={opt.key}
            onClick={() => onToggle(opt.key)}
            className={`px-2 py-0.5 rounded transition-colors select-none ${
              isActive
                ? 'bg-gray-700 text-white'
                : 'bg-gray-800/50 text-gray-500 hover:text-white hover:bg-gray-700'
            }`}
          >
            {opt.label}{icon}
          </button>
        )
      })}
    </div>
  )
}
